// extracted by mini-css-extract-plugin
export var checkbox = "_41-0";
export var circle = "_41-3";
export var horizontalContainer = "_41-7";
export var sm = "_41-5";
export var switch0 = "_41-2";
export var switchDisabled = "_41-8";
export var switchEnabled = "_41-1";
export var textSwitchContainer = "_41-9";
export var textSwitchOption = "_41-a";
export var textSwitchOptionSelected = "_41-b";
export var verticalContainer = "_41-6";
export var xs = "_41-4";